import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-187" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-primary/30 border-l-4 border-l-accent bg-surface p-4 pr-10 text-foreground shadow-2xl shadow-black/50" aria-live="polite" data-id="element-188" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" aria-label="Dismiss notice" data-id="element-189" data-mp="1sgfp5hsodycs">
            <XIcon className="h-4 w-4" data-id="element-190" data-mp="1nfs0h2rx5tlq" />
          </button>
          <div className="flex gap-3" data-id="element-191" data-mp="19pes4zb48cvv">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-192" data-mp="19odf4pajhgbi" />
            <div data-id="element-193" data-mp="1eh6jvd60conl">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-highlight" data-id="element-194" data-mp="1ehpqhxq7jqmb">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-195" data-mp="zp5stcltubc9">
                Once your purchase is complete you receive the
                <br data-id="element-196" data-mp="qqsrtmnfapt0" />
                <span className="font-bold text-foreground" data-id="element-197" data-mp="qqaok62cfbbl">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-198" data-mp="voluw6tfj3p2">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}